/** WAŻNE
 * Test implementuje algorytm sprawdzania poprawności numeru NIP.
 * Strona na której można znaleźć więcej informacji na temat algorytmu 
 * oraz sprawdzić czy NIP jest poprawny:
 * https://www.czerwona-skarbonka.pl/walidator-danych-walidacja-pesel-regon-nip-krok-po-kroku/ 
*/

import { IWages } from './ValidationProps'
import { isInvalidNipNumber } from '../../../common/invalidDocumentNumbersConfig'

export const NIPWages: IWages = {
   0: 6,
   1: 5,
   2: 7,
   3: 2,
   4: 3,
   5: 4,
   6: 5,
   7: 6,
   8: 7,
}

const isNIPValid = (nipNumberArrayToCheck: number[]): boolean => {
   const nip = nipNumberArrayToCheck.join('')
   if (isInvalidNipNumber(nip)) {
      return false
   }

   const result = Object.values(NIPWages)
   .map((wage:number, index: number) => (wage * nipNumberArrayToCheck[index]) % 11)
   .reduce((prev, curr) => prev + curr, 0);

   return result % 11 === nipNumberArrayToCheck.at(-1)
}

/**
 * Funkcja zamieniajaca NIP w postaci stringa, na NIP w postaci tablicy z poszczególnymi cyframi.
 * @param nipToConvert 
 * @returns 
 */
const convertNIPToNumberArray = (nipToConvert: string): number[] => {
   const nipNumberArray: number[] = []

   for (const num of nipToConvert) {
      nipNumberArray.push(Number.parseInt(num))
   }

   return nipNumberArray
}



/**
   Funkcja sprawdzająca poprawność numeru NIP na podstawie poszczególnych wag. 
*/
export const hasNIPCorrectFormat = {
   name: 'hasNIPCorrectFormat',
   message: 'Nieprawidłowa wartość',
   test: (nipToCheck: string | undefined) => {
      if(nipToCheck!== undefined && nipToCheck?.length === 10){
         return isNIPValid(convertNIPToNumberArray(nipToCheck))
      }
      else return false
   },
}
